
import { useCallback, useEffect, useState } from "react";
import { CampaignType } from "../apis/campaign";
import { useQueryState } from "@/utils/use-query";
import Detail from "./campaign-detail";
import ListCampaign from "./campaign-list";

type Props = {
    data: CampaignType[];
};

type StateQuery = {
    id: number;
};

export default function CampaignContent({ data = [] }: Props) {
    const [openDetail, setOpenDetail] = useState(false);
    const { state, setQueryState } = useQueryState<StateQuery>({
        id: (data[0]?.id || 0) as any,
    });

    const [dataCurrentSelect, setDataCurrentSelect] = useState<CampaignType | undefined>(() => {
        return data.find((item) => item?.id === state.id);
    });

    const handleOpenDetail = useCallback(() => {
        setOpenDetail(true);
    }, []);

    const handleCloseDetail = useCallback(() => {
        setOpenDetail(false);
    }, []);

    const handleSelectCampaign = useCallback(
        (id: number) => {
            setQueryState({ id: id }, () => {
                if (openDetail) {
                    handleCloseDetail();
                }
            });
        },
        [handleCloseDetail, openDetail, setQueryState]
    );

    useEffect(() => {
        const dataFind = data.find((item) => item.id === Number(state.id));
        setDataCurrentSelect(dataFind ?? data[0]);
    }, [data, state.id]);

    return (
        <div className="flex justify-center container gap-8 mx-auto flex-col md:flex-row p-4">
            <div
                className="md:basis-3/4 relative rounded-lg bg-no-repeat overflow-hidden"
            >

                <img src={dataCurrentSelect?.backgroundImage} className="w-full min-h-[400px]" />

                <div className="absolute z-10 bottom-0 left-0 right-0 p-4 md:p-10 text-white bg-gray-900/70 backdrop-blur-md">
                    <div className="flex items-center gap-x-4 mb-[14px] w-full">
                        <p className="text-white text-base md:text-[40px] md:leading-[48px] font-semibold z-2 basis-3/4">
                            {dataCurrentSelect?.title}
                        </p>
                        <button
                            className="bg-white text-black rounded-full px-4 py-3 w-[91px] font-medium"
                            onClick={handleOpenDetail}
                        >
                            Detail
                        </button>
                    </div>
                    <p className="opacity-60 flex flex-wrap text-balance overflow-hidden break-words text-ellipsis whitespace-wrap">
                        {dataCurrentSelect?.shortDesc}
                    </p>
                </div>


                {openDetail && (
                    <div className="absolute top-0 z-10 bg-black/70 backdrop-blur-md w-full h-full">
                        <Detail data={dataCurrentSelect} onCloseDetail={handleCloseDetail} />
                    </div>
                )}
            </div>

            <div className="md:basis-1/4 overflow-y-scroll no-scrollbar">
                <ListCampaign data={data} idSelect={dataCurrentSelect?.title ?? ""} onSelectCampaign={handleSelectCampaign} />
            </div>
        </div>
    );
}
